import React from 'react';
import { Flex, TextV2, ButtonV2 } from '@withjoy/joykit';
import { ChevronBack } from '@withjoy/joykit/icons';
import { pxToRem } from '@withjoy/joykit/theme';
import { useTranslation } from '@shared/core';

interface PlaceToStayFormHeaderProps
  extends Readonly<{
    isEditMode: boolean;
    onBackClick: () => void;
  }> {}

export const PlaceToStayFormHeader: React.FC<PlaceToStayFormHeaderProps> = ({ isEditMode, onBackClick }) => {
  const { tq } = useTranslation('placeToStayComponent');

  return (
    <Flex
      flexDirection="column"
      paddingX={{ _: 7, sm2: 8 }}
      paddingTop={7}
      alignItems="center"
      width="100%"
    >
      <ButtonV2
        variant="outline"
        border="1px solid"
        borderColor="mono3"
        position="absolute"
        left={pxToRem(24)}
        top={pxToRem(24)}
        height={8}
        minWidth="fit-content"
        minHeight="fit-content"
        padding={pxToRem(7)}
        intent="neutral"
        width={8}
        shape="rounded"
        startIcon={<ChevronBack size={16} />}
        onClick={onBackClick}
      />
      <Flex
        flexDirection="column"
        gap={4}
        alignItems="center"
        marginBottom={7}
      >
        <Flex
          flexDirection="column"
          alignItems="center"
          textAlign="center"
          gap={1}
          maxWidth={320}
        >
          <TextV2
            typographyVariant="hed5"
            color="mono14"
          >
            {isEditMode ? tq`Edit Place to Stay` : tq`Add Place to Stay`}
          </TextV2>
          <TextV2
            color="mono12"
            typographyVariant="body2"
            lineHeight={pxToRem(25.5)}
          >
            {isEditMode ? tq`Update the hotel suggestion for your guests.` : tq`Add a hotel suggestion for your guests to make their trip planning easier.`}
          </TextV2>
        </Flex>
      </Flex>
    </Flex>
  );
};
